import {
  Grid,
  TextField,
  IconButton,
  Tooltip,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  Typography,
  Container,
  Card,
  Grow,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  CardContent,
  Paper,
} from "@mui/material";
import { Box } from "@mui/system";
import { ListSkeleton } from "components/listSkeleton";
import React from "react";
import { ReactElement, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "redux/store/store";
import RefreshIcon from "@mui/icons-material/Refresh";
import AddIcon from "@mui/icons-material/Add";
import style from "./index.module.scss";
import { getAllTriggers } from "redux/actions/triggerActions";
import { TriggersForm } from "./triggersForm";
import { MenuProps } from "styles/global.styles";

interface State {
  editing: boolean;
  editItem?: any;
  lang?: any;
}

export default function TriggersScreen(): ReactElement {
  const languageType = [
    "defaultcontent",
    "en",
    "hi",
    "te",
    "gu",
    "ta",
    "ka",
    "mr",
    "it",
    "ru",
    "es",
    "fr",
    "pt",
    "de",
    "bn",
    "ml",
    "uk",
    "od",
    "enUs",
    "enAu",
    "pa",
    "ja"
  ];

  const dispatch = useDispatch();
  const triggerList = useSelector((state: RootState) => state.trigger.triggersList);
  const languages = useSelector((state: RootState) => state.app.languages);

  const initialState: State = {
    editing: false,
    editItem: null,
    lang: 1,
  };

  const [language, setLanguage] = useState<any>(1);

  const [currentIndex, setcurrentIndex] = useState(0);
  const [searchTrigger, setSearchTrigger] = useState("");
  const [searchData, setsearchData] = useState<any[]>([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [states, setStates] = useState<State>(initialState);

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setPageNumber(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setPageSize(+event.target.value);
    setPageNumber(0);
  };

  const onClickBack = () => {
    setcurrentIndex(0);
    setSearchTrigger("");
    setStates({
      editing: false,
      editItem: null,
      lang: language,
    });
  };

  useEffect(() => {
    dispatch(getAllTriggers({ pageNumber, pageSize }));
  }, [dispatch, pageSize, pageNumber]);

  const renderMoodsList = (data: any) => {
    return (
      <div>
        {data.length ? (
          <>
            <Grid
              style={{ backgroundColor: "transparent" }}
              className="d-flex py-2 pl-3 align-items-center"
            >
              <Grid className="d-flex flex-grow-1">
                <TextField
                  type="search"
                  fullWidth
                  variant="outlined"
                  placeholder="Search mood by title"
                  size="small"
                  onChange={e => {
                    setSearchTrigger(e.target.value);
                    const filteredData = data.filter((item: any) =>
                      item.tiggername[languageType[language - 1]]
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase()),
                    );
                    setsearchData(filteredData);
                  }}
                  className="mr-2"
                />
              </Grid>
              <Grid className="d-flex align-items-center">
                <IconButton
                  onClick={() => {
                    dispatch(getAllTriggers({ pageNumber, pageSize }));
                  }}
                  size="large"
                >
                  <Tooltip title="Refresh">
                    <RefreshIcon />
                  </Tooltip>
                </IconButton>
              </Grid>
            </Grid>
            <TableContainer style={{ maxHeight: "400px" }} className={style.scrollbar}>
              <Table stickyHeader aria-label="sticky table" size="small">
                <TableHead>
                  <TableRow style={{ fontWeight: "bold" }}>
                    <TableCell align="left" sx={{ width: "20%" }}>
                      Trigger Id
                    </TableCell>
                    <TableCell align="left">Trigger name</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(searchTrigger !== "" ? searchData : data).map((item: any, x: any) => (
                    <React.Fragment key={x}>
                      <TableRow
                        sx={{ cursor: "pointer", height: "50px" }}
                        hover
                        onClick={() => {
                          setStates({
                            editing: true,
                            editItem: item,
                            lang: language,
                          });
                          setcurrentIndex(1);
                        }}
                      >
                        <TableCell align="left">{item.id}</TableCell>
                        <TableCell align="left">
                          {item.tiggername[languageType[language - 1]]
                            ? item.tiggername[languageType[language - 1]]
                            : item.tiggername[languageType[0]]}
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 100]}
              component="div"
              count={triggerList.triggers.pageable?.totalcount ?? 0}
              page={pageNumber}
              onPageChange={handleChangePage}
              rowsPerPage={pageSize}
              onRowsPerPageChange={handleChangeRowsPerPage}
              style={{ borderTop: "1px solid rgba(0, 0, 0, 0.12)" }}
              className={style.scrollbar}
            />
          </>
        ) : (
          <Box height={350}>
            <Grid
              container
              style={{
                height: "100%",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography variant="h6" color="textSecondary">
                No triggers to show
              </Typography>
            </Grid>
          </Box>
        )}
      </div>
    );
  };

  return (
    <Container>
      <Grid container>
        <Grid item xs={12}>
          <Card className="mt-3 mb-5">
            <Grow
              in={currentIndex === 0}
              mountOnEnter
              unmountOnExit
              style={{ transformOrigin: "0 0 0" }}
              {...(currentIndex === 0 ? { timeout: 1000 } : {})}
            >
              <div>
                <Grid container className="align-items-center p-3" spacing={2}>
                  <Grid item>
                    <Typography variant="h6">All Triggers</Typography>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        setcurrentIndex(1);
                      }}
                      startIcon={<AddIcon />}
                    >
                      Create Trigger
                    </Button>
                  </Grid>
                </Grid>
                <Grid item xs={6} sm={4} md={4} lg={3}>
                  <FormControl variant="outlined" className="m-3" fullWidth>
                    <InputLabel id="language-select">Language</InputLabel>
                    {languages && (
                      <Select
                        defaultValue=""
                        labelId="language-select"
                        value={language}
                        label="Language"
                        onChange={e => {
                          setLanguage(e.target.value as number);
                        }}
                        MenuProps={MenuProps}
                      >
                        {languages.map((lang: any, i: any) => (
                          <MenuItem key={i} value={lang.code}>
                            {lang.displayName}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  </FormControl>
                </Grid>
                <Divider />
                <CardContent>
                  <Paper>
                    {triggerList.loading
                      ? ListSkeleton()
                      : renderMoodsList(triggerList.triggers.moodtriggerresponseList)}
                  </Paper>
                </CardContent>
              </div>
            </Grow>
            <Grow
              in={currentIndex === 1}
              mountOnEnter
              unmountOnExit
              style={{ transformOrigin: "0 0 0" }}
              {...(currentIndex === 1 ? { timeout: 1000 } : {})}
            >
              <TriggersForm
                isEditing={states.editing}
                editItem={states.editItem}
                onClickBack={onClickBack}
                lang={language}
                setPage={setPageNumber}
                pageable={{ pageNumber, pageSize }}
              />
            </Grow>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}
